/**
 * Slot for adding custom analytics logging solutions for JD events.
 */

import { Event, EventParameters } from '~/jobiqo/lib/analytics';

/**
 * Allows for an analytics dispatch for a certain event.
 *
 * @param event
 *   The event to dispatch.
 * @param params
 *   The event parameters.
 * @param value
 *   The value for the event.
 */
export function logAnalyticsEventSlot(
  event: Event,
  params: EventParameters = {},
  value = 1,
) {}

/**
 * Only implement this function if you are not using Google analytics.
 *
 * in the original implementation of GA4 we have polling for some events, however the polling works
 * by checking the window.gtag object, if it is not present, it will keep polling until it is present. if you don' t use GA4 you might have
 * to implement a similar polling mechanism for your analytics solution. This could also be necessary in case the analytics solution is loaded
 * asynchronously or is slower than the GA4 script.
 */
export const pollLogAnalyticsEventSlotImplemented = false;
export function pollLogAnalyticsEventSlot(
  event: Event,
  params: EventParameters = {},
  value: number = 1,
  time: number = 500,
  counter: number = 1,
  maximumTries: number = 30,
) {}

/**
 * Mock function to be used in the client's custom tests.
 *
 * @param body
 *   The body containing event and params.
 */
export function callMockEventSlot(body: { event: string; params: any }) {}
